// extracted by mini-css-extract-plugin
export default {"container":"TypingChallengeLeaderboard_container__VLc0o"};